import { Resolve } from '@angular/router';
import { EstadoService } from 'app/services/estado.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EstadoResolver implements Resolve<any> {
    constructor(
        private estadoService: EstadoService
    ) { }

    resolve() {
        return this.estadoService.lista();
    }
}
